var masonry = new MiniMasonry({
    container: '.review-slider-container .reviews',
    baseWidth: 325,
    gutter: 40,
});

document.querySelector('.review-slider-container').closest('.shopify-section').previousElementSibling.style.position = 'relative';
document.querySelector('.review-slider-container').closest('.shopify-section').previousElementSibling.style.zIndex = 2;
document.querySelector('.review-slider-container .review-slider-background').style.display = 'block';

const reviewsContainer = document.querySelector('.review-slider-container .reviews');
const reviewsContainerHeight = reviewsContainer.offsetHeight;
const viewportHeight = window.innerHeight;

let isIntersecting = false;
let containerTop = 0;
let containerBottom = 0;
let scrollStart = 0;

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        isIntersecting = entry.isIntersecting;
        if (isIntersecting) {
            const rect = entry.boundingClientRect;
            containerTop = window.scrollY + rect.top;
            containerBottom = containerTop + rect.height;
            scrollStart = containerTop + (rect.height * 0.33); // Start at 33% visibility
        }
    });
}, {
    threshold: [0, 0.33, 1] // Trigger at 0%, 33%, and 100%
});

observer.observe(reviewsContainer);

window.addEventListener('scroll', () => {
    if (isIntersecting) {
        const scrollY = window.scrollY;
        const viewportBottom = scrollY + viewportHeight;
        
        if (viewportBottom > scrollStart && scrollY < containerBottom) {
            const scrollableDistance = containerBottom - scrollStart;
            const scrolled = viewportBottom - scrollStart;
            const progress = Math.max(0, Math.min(1, scrolled / scrollableDistance));
            const translateY = progress * (reviewsContainerHeight - viewportHeight);
            
            reviewsContainer.style.transform = `translateY(-${translateY}px)`;
        } else if (viewportBottom <= scrollStart) {
            reviewsContainer.style.transform = 'translateY(0)';
        }
    }
});